import { createTheme, responsiveFontSizes, Theme, PaletteOptions, ThemeOptions } from '@mui/material/styles'
import { deepmerge } from '@mui/utils'
import { flowLightPalette } from '../flow'
import { e3dcOverrides } from '../e3dc/overrides'
import { e3dcLightPalette } from '../e3dc'
import { e3dcThemeOptions } from '../e3dc/theme-options'
import { OverridesStyleRules } from '@mui/material/styles/overrides'
import { flowThemeOptions } from '../flow/theme-options'
import { flowOverrides } from '../flow/overrides'

export const getLightFlowTheme = (): Theme => {
  return createCustomTheme(flowThemeOptions, flowLightPalette, flowOverrides)
}

export const getLightE3dcTheme = (): Theme => {
  return createCustomTheme(e3dcThemeOptions, e3dcLightPalette, e3dcOverrides)
}

/**
 * Creates a custom MUI theme with specified options, palette, and overrides.
 *
 * @param themeOptions
 * @param palette
 * @param overrides
 * @returns
 */
const createCustomTheme = (themeOptions: ThemeOptions, palette: PaletteOptions, overrides: (theme: Theme) => OverridesStyleRules): Theme => {
  const theme = createTheme({
    ...themeOptions,
    palette: palette,
  })
  const themeOverrides = overrides(theme)
  const newTheme = deepmerge(theme, { components: themeOverrides })
  return responsiveFontSizes(newTheme)
}
